export default __webpack_public_path__ + "static/media/cloud.2146fc88.svg";